<template>
  <div class="step-four" id="step-four">
    <h2 class="fs-24 font-smoothing">Betaling</h2>
    <step>
      <p class="color-grey-3 font-smoothing fs-14 mb-2 mt-4">Tilføj en kommentar</p>
      <textarea rows="4" class="w-100 input-default" placeholder="Angiv her om du har nogle kommentar vi skal være opmærksomme på" v-model="comment" />

      <div class="d-block d-lg-flex mt-2" >
        <div class="w-100 w-lg-50 mt-lg-0">
          <p class="color-grey-3 font-smoothing fs-14 mb-2">Anvend rabatkode</p>
          <input class="input-default w-100" type="text" placeholder="Rabatkode" @blur="validateCoupon" v-model="coupon" :class="{'error-border' : couponError}">
          <p v-if="couponExpirydate && !couponError" class="color-blue font-smoothing fs-12 mt-2 ml-1">{{'Udløbsdato: ' + couponExpirydate}}</p>
          <p v-if="couponWasExpired" class="italic color-grey-3 font-smoothing fs-12 mt-2 ml-1 text-danger">Rabatkode er udløbet</p>
          <p v-if="couponError" class="italic color-grey-3 font-smoothing fs-12 mt-2 ml-1 text-danger">{{couponType === 'Value card' ? 'Rabatkode er udløbet' : 'Ikke fundet'}}</p>
        </div>
      </div>     
      
      <p class="text-danger font-smoothing fs-14 mb-2 mt-4">Statsborgerskab</p>

      <textarea
        v-model="statsborgerskab"
        class="w-100 input-default"
        placeholder="Skriv her hvilke statsborgerskaber du/I har hvis andet end dansk - så vi bedre kan rådgive om de rette rejseregler"
        rows="2"
      />

      <div v-if="Number(contact.address.zip) < puroadLevel.maxPostalNumber" class="modtage-bagagen__wrapper">
        <p class="modtage-bagagen__wrapper--header">
          {{ luggageQuestionText }}
          <span class="asterisk">*</span>

          <i
            v-tooltip="{
              content: 'Du skal vælge enten at mødes med os ved vejkanten og spare penge, eller at vi kommer op til dig i lejligheden mod en ekstra pris',
              placement: 'top',
              offset: '1px',
              trigger: 'hover click',
            }"
            class="modtage-bagagen__tooltip icon-question ml-2 color-blue"
          />
        </p>

        <div class="modtage-bagagen__wrapper--container">
          <div class="radio-block" @click="setPuroadLevelValue('yes')">
            <input :checked="puroadLevel.value === 'yes'" type="radio">
            <span>{{ yesOptionText }}</span>
          </div>
  
          <div class="radio-block" @click="setPuroadLevelValue('no')">
            <input :checked="puroadLevel.value === 'no'" type="radio">
            <span>{{ noOptionText }}</span>
          </div>
        </div>
        
      </div>
      
      <div class="d-flex mt-3 align-items-center">
         <boolean-slider
          v-model="newsletter"
          label="Modtag relevant rejseinformation og gode tilbud"
        />
      </div>
        <boolean-slider
          v-model="termsAccepted"
          class="mt-4"
          label="<a href='https://www.valizo.eu/betingelser/' target='_blank'>Accepter handelsvilkår</a> og
            <a href='https://www.valizo.eu/privatliv/' target='_blank'>Privatlivsbetingelser</a>"
        />
    </step>
  </div>
</template>

<script>
import Step from '@/components/Step'
import BooleanSlider from '@/components/BooleanSlider'
import { mapFields } from 'vuex-map-fields'
import { mapMutations, mapGetters } from 'vuex'
import { page } from 'vue-analytics'
import axios from 'axios' 

export default {
  name: 'StepFour',
  data() {
    return {
      paymentOptions: [
        { label: 'Betalingskort', value: 'Betalingskort' },
        { label: 'Betal ved afhentning (MobilePay eller kontant)', value: 'Mobilepay'}
      ]
    }
  },
  components: {
    Step,
    BooleanSlider
  },
  computed: {
    ...mapFields([
      'payment.type',
      'payment.coupon',
      'payment.comment',
      'payment.statsborgerskab',
      'payment.termsAccepted',
      'payment.newsletter',
      'payment.couponType',
      'payment.couponError',
      'payment.couponExpirydate',
      'payment.couponWasExpired',
      'payment.totalPreCoupon'
    ]),
    ...mapGetters(['prices', 'contact', 'puroadLevel', 'cart']),
    isStepValid () {
      const { value, maxPostalNumber } = this.puroadLevel;

      return this.termsAccepted && ((Number(this.contact.address.zip) >= maxPostalNumber) || (Number(this.contact.address.zip) < maxPostalNumber && value));
    },
    luggageQuestionText() {
      const { serviceUdrejse, serviceHjemrejse } = this.cart;
      
      if (!serviceUdrejse && serviceHjemrejse) {
        // Only Hjemrejse selected
        return `Kan vi bringe bagagen til vejkanten (spar ${this.puroadLevel.fee} kr)?`;
      } else if (serviceUdrejse && serviceHjemrejse) {
        // Both services selected - price is 300 DKK
        return `Kan vi modtage/bringe bagagen til vejkanten (spar 300 kr)?`;
      } else {
        // Only Udrejse or no services - keep original text
        return `Kan vi modtage bagagen ved vejkanten (spar ${this.puroadLevel.fee} kr)?`;
      }
    },
    yesOptionText() {
      const { serviceUdrejse, serviceHjemrejse } = this.cart;
      
      if (!serviceUdrejse && serviceHjemrejse) {
        // Only Hjemrejse selected
        return `Ja, jeg sørger for bagagen er bragt til min vejkant eller stuetage hvor VALiZO kan parkere ved gadedør.`;
      } else if (serviceUdrejse && serviceHjemrejse) {
        // Both services selected
        return `Ja, jeg sørger for bagagen er hentet/bragt til vejkant eller stuetage hvor VALiZO kan parkere ved gadedør.`;
      } else {
        // Only Udrejse or no services - keep original text
        return `Ja, jeg sørger for bagagen er ved vejkant eller stuetage hvor VALiZO kan parkere ved gadedør.`;
      }
    },
    noOptionText() {
      const { serviceUdrejse, serviceHjemrejse } = this.cart;
      
      if (!serviceUdrejse && serviceHjemrejse) {
        // Only Hjemrejse selected
        return `Nej Jeg vil gerne have bragt til min lejlighed (+${this.puroadLevel.fee} kr).`;
      } else if (serviceUdrejse && serviceHjemrejse) {
        // Both services selected - price is 300 DKK
        return `Nej Jeg vil gerne have hentet/bragt til lejlighed (+300 kr).`;
      } else {
        // Only Udrejse or no services - keep original text
        return `Nej Jeg vil gerne have hentet i min lejlighed (+${this.puroadLevel.fee} kr).`;
      }
    }
  },
  mounted() {
    this.isStepValid ? this.$emit('valid') : this.$emit('invalid')

    page('/stepFour')
  },
  methods: {
    ...mapMutations(['setCoupon', 'setPuroadLevelValue']),

    async validateCoupon() {
      try {
        const coupon = await axios(process.env.VUE_APP_API_URL + '/coupon', {
          method: 'POST',
          data: {
            coupon: this.coupon,
            email: this.contact.email,
            price: this.prices.total,
          }
        })

        if (coupon.status === 200) {
          this.setCoupon(coupon.data)
        }
        
      } catch (err) {
        this.setCoupon(null)
      }
    },
  }, 
  watch: {
    'isStepValid': {
        handler (value) {
          if (value) {
            this.$emit('valid')
          } else {
            this.$emit('invalid')
          }
        },
        deep: true
    },
    newsletter(newsletteraccept) {
      if (!newsletteraccept && this.coupon.toLowerCase() == 'gratis02') { //nyhedsbrev og kode hænger sammen
        alert('Denne rabatkode gælder ved tilmelding til nyhedsbrev');
        this.newsletter=true;
      } 

    }
  }
}
</script>

<style lang="scss" scoped>
  @use "../assets/scss/media-queries" as *;

  .step-four {
    padding: 60px 0 0;

    h2 {
      padding-left: 80px;
      margin-bottom: 60px;
    }

    .step {
      border-bottom: 0;
      padding: 60px 80px 140px;
      position: relative;

      @include max-screen(991px) {
        padding: 30px 30px 140px;
      }

      .back-btn {
        left: 0;
        bottom: 0;
      }
    }
  }

  .modtage-bagagen {
    &__tooltip {
      cursor: help;
    }

    &__wrapper {
      display: flex;
      flex-direction: column;
      margin-top: 12px;

      &--header {
        transition: color .5s ease-in-out;
        font-weight: 600;
        margin-bottom: 0px;
      }

      &--container {
        .radio-block {
          transition: background-color .2s ease-in-out;
          width: fit-content;
          display: flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
          padding: 2px 8px;
          border-radius: 4px;

          &:hover {
            background-color: rgba(46, 164, 242, 0.15);
          }
          
          input {
            min-width: 16px; min-height: 16px;
          }
        }
      }
    }
  }
</style>
